module.exports = __webpack_public_path__ + "static/media/4.a1465cb2.svg";